<div class="row item" [formGroup]="accessoryForm">
    <div class="col-md-5 col-xs-12">
        <sc-select formControlName="selectedAccesory" label="" placeholder="Seleccioná un accesorio" enableSearch="true"
            objectValue="name" [itemsAsync$]="accessoryOptions"></sc-select>
    </div>
    <div class="col-md-2 col-xs-12">
        <sc-input formControlName="statedAmount" [pipes]="[{pipe: scCurrency}]" label="" placeholder=""></sc-input>
    </div>
    <div class="col-md-2 col-xs-12 item__actions" *ngIf="isRemovable()">
        <a class="link" (click)="remove()">Eliminar</a>
    </div>
</div>